import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { BiPlus } from "react-icons/bi";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import medicalInstrumentIcon from "../../assets/icons/medical-Instrument.svg";
import ProfileIcon from "../../assets/icons/profile.svg";
import FilterIcon from "../../assets/icons/filter.svg";
import { formateDate, typePersianConverter } from "../../utils/Functions";
import FileViewer from "../../components/common/fileViewer";
import TestFilter from "../../components/test/testFilter";
import Modal from "../../components/common/modal";
import Loading from "../../components/common/loading";
import useStore from "../../features/store";

const Records = () => {
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  //@ts-ignore
  const { records, isLoadingRecords, fetchRecords } = useStore();

  const userInfo = (is_for_other: boolean) => {
    if (is_for_other) return "temp_user";
    else return "creator";
  };

  useEffect(() => {
    if (!records) fetchRecords();

    if (records) setLoading(false);
  }, [records]);

  useEffect(() => {
    if (records) {
      const queryParams = new URLSearchParams(location.search);
      const usersParam = queryParams.get("users")?.split(",") || [];

      const filtered = records?.results.filter((record: any) => {
        const data = record.is_for_other ? record.temp_user : record.creator;

        const userMatch = usersParam.length
          ? //@ts-ignore
            usersParam.includes(
              `${data?.first_name}_${data?.last_name}`?.replace(/ /g, "_")
            )
          : true;

        return userMatch;
      });

      setFilteredRecords(filtered);
    }
  }, [records, location.search]);

  const handleFilterSubmit = (users: string[]) => {
    const queryString = [];
    if (users.length) queryString.push(`users=${users.join(",")}`);
    navigate(`?${queryString.join("&")}`);
    setIsModalOpen(false);
  };

  return (
    <div className="my-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img src={medicalInstrumentIcon} width={28} alt="سوابق آزمایش" />
          <h1 className="font-[800] mr-3 mt-2 font-rokh text-lg">
            سوابق آزمایش
          </h1>
        </div>
        {!isLoadingRecords && (
          <div className="md:hidden inline">
            <button
              className="btn bg-pr_purple border-none rounded-full p-0 w-10 h-10 min-h-[auto]"
              onClick={() => setIsModalOpen(true)}
            >
              <img src={FilterIcon} alt="فیلتر نتایج" />
            </button>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <TestFilter
                records={records?.results}
                onSubmitFilters={handleFilterSubmit}
              />
            </Modal>
          </div>
        )}
      </div>

      {filteredRecords?.length > 0 && (
        <div className="mt-5 mb-3 w-full">
          <Link
            to="/"
            className="btn w-full lg:hidden btn-primary flex items-center"
          >
            <BiPlus
              size={22}
              className="text-white"
              style={{ color: "#fff" }}
            />
            <span className="text-[15px] font-rokh pt-2 font-[900] mr-1 text-white">
              تحلیل آزمایش جدید
            </span>
          </Link>
        </div>
      )}

      <div className="relative flex items-start mt-6">
        {loading || isLoadingRecords ? (
          <Loading type="records" />
        ) : filteredRecords?.length > 0 || records?.results.length > 0 ? (
          <>
            <div className="hidden lg:inline sticky top-10 flex-1 min-w-[350px] p-5 ml-3 rounded-lg bg-pr_purple">
              <Fade triggerOnce>
                <TestFilter
                  records={records.results}
                  onSubmitFilters={handleFilterSubmit}
                />
              </Fade>
            </div>

            <div className="flex-5 w-full grid lg:grid-cols-3 gap-4">
              <Fade triggerOnce>
                {(filteredRecords.length > 0
                  ? filteredRecords
                  : records.results
                )
                  .filter((test: any) => test.files.length)
                  .map((record: any) => (
                    <Link
                      to={`/test-result/${record.id}?step=1`}
                      key={record.id}
                      className="flex flex-col items-center bg-white border-[1px] border-gray-500 rounded-lg"
                    >
                      <div className="flex flex-col items-center justify-between w-full mb-4">
                        <div className="relative w-full border-b-2 overflow-hidden rounded-t-lg">
                          <FileViewer file={record.files[0].url} />

                          <div
                            className="absolute left-0 bottom-0 w-full p-2 h-full flex items-end justify-center"
                            style={{
                              background: `linear-gradient(180deg, rgba(0,0,0,.1) 0%, rgba(0,0,0,.8) 100%)`,
                            }}
                          ></div>
                          <span className="absolute right-2 top-2 bg-gray-100 rounded-full px-4 pt-[6px] pb-1 font-rokh font-[700] text-xs text-black">
                            تحلیل{" "}
                            {record.is_pro_analysis ? "پیشـــرفته" : "پـــایه"}
                          </span>
                        </div>
                        <div className="w-full px-4 mt-3">
                          <div className="flex-1">
                            <h2 className="font-[900] text-lg font-rokh my-1">
                              تحلیل آزمایش پزشکی
                            </h2>
                            <div className="flex items-center justify-between">
                              <h4 className="text-sm flex items-center">
                                <img
                                  src={ProfileIcon}
                                  width={16}
                                  alt="پروفایل"
                                  className="ml-1"
                                />
                                {`${
                                  record[userInfo(record.is_for_other)]
                                    ?.first_name
                                } ${
                                  record[userInfo(record.is_for_other)]
                                    ?.last_name
                                }`}
                              </h4>
                              <h6 className="text-sm text-gray-700">
                                {formateDate(record.created_at)}
                              </h6>
                            </div>
                          </div>

                          <div className="mt-3 flex items-center justify-end">
                            <div className="bg-pr_blue flex items-center justify-center rounded-lg px-3 py-2 mt-5 w-full">
                              <span className="text-sm ml-2 mt-1 font-rokh font-[700]">
                                مشاهده
                              </span>
                              <HiOutlineArrowLongLeft
                                size={20}
                                className="text-black"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </Fade>
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center w-full mt-20">
            <h5 className="font-bold text-xl">هنوز آزمایشی ثبت نشده!</h5>
            <Link to="/" className="btn btn-primary mt-6 px-10">
              ثبت آزمایش جدید{" "}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Records;
